import { useEffect, useState } from 'react';
import { useDebounce } from 'usehooks-ts';
import { LocationUsersV3 } from '../../../../backbone-unorganized/shared/forms';
import { MentionableUser } from './useMentionState';

interface UserModel {
    get: (key: string) => unknown;
    get_display_name: () => string;
}

export const useMentionSearch = (query: string, enabled: boolean, locationId?: number) => {
    const debouncedQuery = useDebounce(query, 300);
    const [users, setUsers] = useState<MentionableUser[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!enabled || !locationId) {
            setUsers([]);
            return;
        }

        setIsLoading(true);
        const collection = new LocationUsersV3([]);
        collection.location_id = locationId;
        collection.paginator.set({
            search: debouncedQuery,
            limit: 20
        });

        collection.fetch({
            success: () => {
                setUsers(
                    collection.map((model: UserModel) => ({
                        id: model.get('id') as number,
                        displayName: model.get_display_name(),
                        userRole: (model.get('userprofile__user_role__name') as string | null) ?? null
                    }))
                );
                setIsLoading(false);
            },
            error: () => setIsLoading(false)
        });
    }, [debouncedQuery, enabled, locationId]);

    return { users, isLoading, debouncedQuery };
};
